import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { fetchAttendanceDetails } from '../../../store/apis/attendanceService';
import { DateUtil } from '../../../utils';
import './AttendanceWidget.scss';
import * as icons from '../../../assets';
import { withBase } from '../../../utils/route.util';

function AttendanceWidget() {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const currentMonthStart = new Date(currentYear, currentMonth, 1);
  const { year, month, fromDate, toDate } =
    DateUtil.getMonthData(currentMonthStart);

  const { data: attendanceData } = useQuery({
    queryKey: ['attendanceData', year, month],
    queryFn: () =>
      fetchAttendanceDetails({
        fromDate,
        toDate,
        type: 'SUMMARY',
      }),
    enabled: true,
  });

  return (
    <Card className="attendance-widget">
      <CardHeader className="pb-1 attendance-widget__header">
        <div className="d-flex flex-row align-items-center gap-2 attendance-widget__header-row">
          <img
            src={icons.iconsDashboardAttendance}
            alt="Attendance Icon"
            height="20px"
          />
          <span className="attendance-widget__header-title fs-5">
            Attendance – ({`${month} ${year}`})
          </span>
        </div>
      </CardHeader>

      <CardBody className="px-3 py-1 attendance-widget__body overflow-hidden">
        <div className="gap-2 attendance-widget__content">
          <div
            className="d-flex flex-column gap-1 text-center attendance-widget__item"
            title="Average time you clocked in over the selected period (Month)."
          >
            <span className="attendance-label">Avg Time In</span>
            <span className="attendance-widget__item-value fs-4">
              {(attendanceData && attendanceData.data?.[0]?.TimeIn) || '-'}
            </span>
          </div>

          <div className="attendance-widget__item-separator" />

          <div
            className="d-flex flex-column gap-1 text-center attendance-widget__item"
            title="Average time you clocked out over the selected period (Month)."
          >
            <span className="attendance-label">Avg Time Out</span>
            <span className="attendance-widget__item-value fs-4">
              {(attendanceData && attendanceData.data?.[0]?.TimeOut) || '-'}
            </span>
          </div>

          <div className="attendance-widget__item-separator" />

          <div
            className="d-flex flex-column gap-1 text-center attendance-widget__item"
            title="Total number of days you clocked in late. Click to view the late days in your Timesheet."
          >
            <span className="attendance-label">Late Day</span>
            <span
              className="attendance-widget__item-value underline cursor-pointer fs-4"
              onClick={() => {
                window.open(
                  withBase(
                    `/timesheet-statistics?Year=${year}&Month=${currentMonth + 1}`,
                  ),
                  '_blank',
                );
              }}
            >
              {(attendanceData && attendanceData.data?.[0]?.Missing) || 0}
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default AttendanceWidget;
